import Order from '../order/Order';

function MyOrder() {
  return <Order />;
}

export default MyOrder;
